module.exports = __webpack_public_path__ + "img/telegram.557280c2.svg";